import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { GridOperatorPermissionsEnum } from '@fluxonos/fluxonos-dto';

export class PermissionsGridOperatorModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [GridOperatorPermissionsEnum.VIEW__FLUXONOS__GRID_OPERATOR];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [GridOperatorPermissionsEnum.CHANGE__FLUXONOS__GRID_OPERATOR];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [GridOperatorPermissionsEnum.ADD__FLUXONOS__GRID_OPERATOR];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [GridOperatorPermissionsEnum.DELETE__FLUXONOS__GRID_OPERATOR];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}
